module.exports = __webpack_public_path__ + "static/media/tag_list_icon.39dbcf4a.svg";